const campaignFactoryAddress = '0xD731166D5DB1c86ab149352f756ae92C35BfAE20';

export default campaignFactoryAddress;
